<template>
  <div class="personTreaty">
    <div class="freeTreaty-top" @click="goBack">
        <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
        <!-- <div>我的签约</div> -->
        <div></div>
      </div>
    <p>甲方：银行；  乙方：客户</p>
    <p>乙方授权甲方，除法律另有规定之外，将乙方提供给甲方的信息、享受甲方服务产生的信息以及甲方根据本条约定查询、收集的信息，提供给甲方所属集团、服务机构及其他甲方认为必要的业务合作机构，用于为乙方提供服务、推荐产品、开展市场调查与信息数据分析。为确保乙方本人信息的安全，甲方及其合作伙伴对上述信息负有保密义务，并采取各种措施保证信息安全。本条款自签署时生效，具有独立法律效力。如乙方将来不同意本授权条款的部分或全部，可〔致电客服热线（95511）或亲临银行网点〕取消或变更授权。</p>
    <p>信息使用范围包括：（1）适当金融产品推荐；（2）符合客户需求的金融服务；（3）因优化客户服务所需的信息调查与信息分析。</p>
  </div>
</template>
<script>
export default {
  methods:{
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.freeTreaty-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
.personTreaty{
  padding: 30px;
  p{
    line-height: 42px;
    text-align: left;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/treaty/personTreaty/index.vue